import { useQuery } from "@tanstack/react-query"
import { makeListSynthesisSessions } from "../../domain/use-cases/list-synthesis-sessions"
import { httpSynthesisSessionRepository } from "../../data/repositories/synthesis-session-repository"

const listSessions = makeListSynthesisSessions(httpSynthesisSessionRepository)

export const useSynthesisSessions = () =>
  useQuery({
    queryKey: ["synthesis-sessions"],
    queryFn: listSessions,
  })
